export const TOPLINE_MENU_CODE = import.meta.env.VITE_HIVE_TOPLINE_MENU_CODE ?? 'topline-menu'
export const CATALOG_LINE_MENU_CODE = import.meta.env.VITE_HIVE_CATALOG_LINE_MENU_CODE ?? 'catalog-menu'

export const CATEGORIES_MODAL_BANNER_CODE = import.meta.env.VITE_HIVE_CATEGORIES_MODAL_BANNER_CODE ?? 'categories-modal'